import { render } from "./GridItem.vue?vue&type=template&id=3b8285c9"
import script from "./GridItem.vue?vue&type=script&lang=js"
export * from "./GridItem.vue?vue&type=script&lang=js"

import "./GridItem.vue?vue&type=style&index=0&id=3b8285c9&lang=scss"
script.render = render

export default script